import { useMutation, useQueryClient } from 'react-query';

import { quoteBindAxios } from 'lib/quoteBind';
import { QB_RISK_ENDORSEMENTS } from 'lib/quoteBind/queryKeys';
import * as utils from 'utils';
import { logoutAuth0 } from 'utils/auth0/auth0';

export const useGetRefreshedEndorsements = () => {
  const queryClient = useQueryClient();

  const handleError = (err) => {
    const errorParams = {
      file: 'quoteBind.queries.useGetEndorsementRiskData',
    };

    utils.api.handleError(err, errorParams);
    utils.api.handleUnauthorized(err, null, logoutAuth0);
  };

  return useMutation(
    async ({ riskId }) => {
      const result = await quoteBindAxios.get(`endorsements/risk/${riskId}?refresh=true`);
      return { riskId, endorsements: result?.data };
    },
    {
      onSuccess: async ({ riskId, endorsements }) => {
        queryClient.setQueryData([QB_RISK_ENDORSEMENTS, riskId], endorsements);
      },
      onError: (err) => handleError(err),
    }
  );
};
